import React from "react";

const VegetableShowcase = () => {
  return (
    <section className="bg-green-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-green-800 mb-4">
            Our Premium Vegetables
          </h2>
          <p className="text-xl text-green-700 max-w-3xl mx-auto">
            Discover the freshness and quality of our carefully selected vegetables, sourced from the best farms.
          </p>
        </div>

        {/* Vegetable Cards Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {/* Palak (Spinach) Card */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <img
              src="/image6.png"
              alt="Fresh Palak (Spinach)"
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h3 className="text-2xl font-bold text-green-700 mb-2">Spinach</h3>
              <p className="text-gray-600 mb-4">
                Our palak is harvested at peak freshness, delivering tender, dark green leaves packed with iron and vitamins. Perfect for saag, smoothies, or salads. Grown organically without pesticides.
              </p>
              <div className="flex items-center text-sm text-gray-500">
                <svg className="w-4 h-4 mr-1 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Rich in iron & vitamins</span>
              </div>
            </div>
          </div>

          {/* Gajar (Carrot) Card */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <img
              src="/image7.png"
              alt="Fresh Gajar (Carrot)"
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h3 className="text-2xl font-bold text-green-700 mb-2">Carrot</h3>
              <p className="text-gray-600 mb-4">
                Our carrots are sweet, crunchy, and vibrant orange. Handpicked for their natural sweetness and high beta-carotene content. Ideal for juices, salads, curries, and desserts like gajar ka halwa.
              </p>
              <div className="flex items-center text-sm text-gray-500">
                <svg className="w-4 h-4 mr-1 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>High in beta-carotene</span>
              </div>
            </div>
          </div>

          {/* Baingan (Eggplant) Card */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <img
              src="/image4.png"
              alt="Fresh Baingan (Eggplant)"
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h3 className="text-2xl font-bold text-green-700 mb-2">Eggplant</h3>
              <p className="text-gray-600 mb-4">
                Our baingan features glossy purple skin and firm, creamy flesh. Perfect for baingan bharta, stuffed eggplant, grilling, or curries. Grown with care to ensure rich flavor and texture.
              </p>
              <div className="flex items-center text-sm text-gray-500">
                <svg className="w-4 h-4 mr-1 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Rich in fiber & antioxidants</span>
              </div>
            </div>
          </div>
        </div>

        {/* Optional bottom CTA */}
        <div className="text-center mt-12">
          <a
            href="#products"
            className="inline-flex items-center px-8 py-4 bg-green-600 text-white font-semibold rounded-md hover:bg-green-700 transition shadow-lg"
          >
            Explore All Vegetables
            <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default VegetableShowcase;